import {Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {ActionOpenLinkToRoute} from 'src/api/cargo-c2c/types'
import {tagToUrl} from 'src/utils'

import {classes} from '../support-button/SupportButton.classes'

type Props = {
  action: ActionOpenLinkToRoute
}

export function UniversalLink({action}: Props): React.ReactElement {
  return (
    <>
      <a
        className={classes.action}
        href={action.url}
        onClick={console.log}
        rel="noreferrer"
        style={{backgroundImage: `url("${tagToUrl(action.image_tag)}")`}}
        target="_blank"
      />
      <Typography color="minor" justifyContent="center" variant="caption1">
        {action.title}
      </Typography>
    </>
  )
}
